export const UG_MOTOR_INSURANCE_DOCUMENTS_FORM = 'ugMotorInsurance/documentsForm/';

export const MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE = UG_MOTOR_INSURANCE_DOCUMENTS_FORM + 'setValue/';
export const MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID = UG_MOTOR_INSURANCE_DOCUMENTS_FORM + 'setValid/';

export const FORM_VALID_MOTOR_INSURANCE_DOCUMENTS_FORM = 'ugMotorInsurance/documentsForm/transition/formValid';
export const FORM_INVALID_MOTOR_INSURANCE_DOCUMENTS_FORM = 'ugMotorInsurance/documentsForm/transition/formInValid';

export const REINITIALIZE = 'ugMotorInsurance/documentsForm/state/reinitialize';

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_DOCUMENTS_FORM = 'ugMotorInsurance/documentsForm/transition/dropOffLead';
export const dropOffLeadDocuments = (value) => ({
    type: DROP_OFF_LEAD_TRANSITION_DOCUMENTS_FORM,
    value,
});

export const transitionMotorInsuranceDocumentsForm = {
    formValid: () => ({
        type: FORM_VALID_MOTOR_INSURANCE_DOCUMENTS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_MOTOR_INSURANCE_DOCUMENTS_FORM,
    }),
};

// API Calls actions
export const API_PENDING_TRANSITION_DOCUMENTS_FORM = `${MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_DOCUMENTS_FORM = `${MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_DOCUMENTS_FORM = `${MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE}/apiTransition/failure`;

export const apiTransitionDocumentsForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_DOCUMENTS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_DOCUMENTS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_DOCUMENTS_FORM,
    }),
};

export const SUBMIT_DOCUMENTS_DATA = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'submitDocumentsData';

export const submitDocumentsFormData = () => ({
    type: SUBMIT_DOCUMENTS_DATA,
});

export const UPLOAD_UG_DOCUMENT_DATA = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'uploadUgDocumentData';

export const uploadUgDocumentsData = () => ({
    type: UPLOAD_UG_DOCUMENT_DATA,
});

export const UPLOAD_SINGLE_UG_DOCUMENT = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'uploadSingleUgDocument';

export const uploadSingleUgDocument = () => ({
    type: UPLOAD_SINGLE_UG_DOCUMENT,
});

//calculated Data
export const COLLECT_DOCUMENTS_FORM_DATA = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'collectDocumentsData';
export const SUBMIT_DOCUMENTS_SUCCESS = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'success';
export const SUBMIT_DOCUMENTS_FAILURE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'failure';

export const collectDocumentsData = () => ({
    type: COLLECT_DOCUMENTS_FORM_DATA,
});
export const submitDocumentsDataSuccess = (value) => ({
    type: SUBMIT_DOCUMENTS_SUCCESS,
    value,
});
export const submitDocumentsFailure = (error) => ({
    type: SUBMIT_DOCUMENTS_FAILURE,
    error,
});

// Form Values
export const ID_UPLOAD_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'idUpload';
export const ID_UPLOAD_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'idUpload';

export const LICENSE_UPLOAD_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'licenseUpload';
export const LICENSE_UPLOAD_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'licenseUpload';

export const LOG_BOOK_UPLOAD_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'logBookUpload';
export const LOG_BOOK_UPLOAD_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'logBookUpload';

export const VALUATION_REPORT_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'valuationReport';
export const VALUATION_REPORT_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'valuationReport';

export const INSPECTION_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'inspectionPhoto';
export const INSPECTION_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'inspectionPhoto';

export const EXTRA_PHOTOS_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'extraPhotos';
export const EXTRA_PHOTOS_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'extraPhotos';

export const DOCUMENT_TYPE_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'documentType';
export const DOCUMENT_TYPE_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'documentType';

//additional ug values
export const CAR_FRONT_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'carFrontViewPhoto';
export const CAR_FRONT_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'carFrontViewPhoto';

export const CAR_BACK_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'carBackViewPhoto';
export const CAR_BACK_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'carBackViewPhoto';

export const CHASSIS_NUMBER_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'chassisNumberPhoto';
export const CHASSIS_NUMBER_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'chassisNumberPhoto';

export const INTERIOR_DASHBOARD_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'carDashboardPhoto';
export const INTERIOR_DASHBOARD_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'carDashboardPhoto';

export const INTERIOR_RADIO_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'interiorRadioPhoto';
export const INTERIOR_RADIO_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'interiorRadioPhoto';

export const ENGINE_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'enginePhoto';
export const ENGINE_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'enginePhoto';

export const SALES_AGREEMENT_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'salesAgreement';
export const SALES_AGREEMENT_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'salesAgreement';

export const CAR_RIGHT_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'carRightPhoto';
export const CAR_RIGHT_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'carRightPhoto';

export const CAR_LEFT_PHOTO_SET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'carLeftPhoto';
export const CAR_LEFT_PHOTO_SET_VALID = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALID + 'carLeftPhoto';

// reset individual form value
export const ID_UPLOAD_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/idUpload';
export const LICENSE_UPLOAD_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/licenseUpload';
export const LOG_BOOK_UPLOAD_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/logBookUpload';
export const VALUATION_REPORT_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/valuationReport';
export const INSPECTION_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/inspectionPhoto';
export const EXTRA_PHOTOS_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/extraPhotos';

//additional ug resets
export const CAR_FRONT_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/carFrontViewPhoto';
export const CAR_BACK_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/carBackViewPhoto';
export const CHASSIS_NUMBER_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/chassisNumberPhoto';
export const INTERIOR_DASHBOARD_PHOTO_RESET_VALUE =
    MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/carDashboardPhoto';
export const INTERIOR_RADIO_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/interiorRadioPhoto';
export const ENGINE_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/enginePhoto';
export const SALES_AGREEMENT_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/salesAgreement';
export const CAR_RIGHT_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/carRightPhoto';
export const CAR_LEFT_PHOTO_RESET_VALUE = MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'reset/carLeftPhoto';

export const DOCUMENT_DETAILS_SUBMITTED_SET_VALUE =
    MOTOR_INSURANCE_DOCUMENTS_FORM_SET_VALUE + 'documentDetailsSubmitted';

export const setDocumentDetailsSubmittedValue = (value) => ({
    type: DOCUMENT_DETAILS_SUBMITTED_SET_VALUE,
    value,
});

// ID upload action creators
export const setIdUploadValue = (value) => ({
    type: ID_UPLOAD_SET_VALUE,
    value,
});

export const setIdUploadValid = (error) => ({
    type: ID_UPLOAD_SET_VALID,
    error,
});

export const resetIdUploadValue = () => ({
    type: ID_UPLOAD_RESET_VALUE,
});

// License upload action creators
export const setLicenseUploadValue = (value) => ({
    type: LICENSE_UPLOAD_SET_VALUE,
    value,
});

export const setLicenseUploadValid = (error) => ({
    type: LICENSE_UPLOAD_SET_VALID,
    error,
});

export const resetLisenceUploadValue = () => ({
    type: LICENSE_UPLOAD_RESET_VALUE,
});

// Logbook upload action creators
export const setLogBookUploadValue = (value) => ({
    type: LOG_BOOK_UPLOAD_SET_VALUE,
    value,
});

export const setLogBookUploadValid = (error) => ({
    type: LOG_BOOK_UPLOAD_SET_VALID,
    error,
});

export const resetLogBookUploadValue = () => ({
    type: LOG_BOOK_UPLOAD_RESET_VALUE,
});

// Inspection Photo action creators
export const setInspectionPhotoValue = (value) => ({
    type: INSPECTION_PHOTO_SET_VALUE,
    value,
});

export const setInspectionPhotoValid = (error) => ({
    type: INSPECTION_PHOTO_SET_VALID,
    error,
});

export const resetInspectionPhotoValue = () => ({
    type: INSPECTION_PHOTO_RESET_VALUE,
});

// Inspection Photo action creators
export const setValuationReportUploadValue = (value) => ({
    type: VALUATION_REPORT_SET_VALUE,
    value,
});

export const setValuationReportUploadValid = (error) => ({
    type: VALUATION_REPORT_SET_VALID,
    error,
});

export const resetValuationReportUploadValue = () => ({
    type: VALUATION_REPORT_RESET_VALUE,
});

export const setExtraPhotosValue = (value) => ({
    type: EXTRA_PHOTOS_SET_VALUE,
    value,
});

export const setExtraPhotosValid = (error) => ({
    type: EXTRA_PHOTOS_SET_VALID,
    error,
});

export const resetExtraPhotosValue = () => ({
    type: EXTRA_PHOTOS_RESET_VALUE,
});

//document type
export const setDocumentTypeValue = (value) => ({
    type: DOCUMENT_TYPE_SET_VALUE,
    value,
});

export const setDocumentTypeValid = (error) => ({
    type: DOCUMENT_TYPE_SET_VALID,
    error,
});

//additional ug photo sets
export const setCarFrontViewPhotoValue = (value) => ({
    type: CAR_FRONT_PHOTO_SET_VALUE,
    value,
});
export const setCarFrontViewPhotoValid = (error) => ({
    type: CAR_FRONT_PHOTO_SET_VALID,
    error,
});
export const resetCarFrontViewPhotoValue = () => ({
    type: CAR_FRONT_PHOTO_RESET_VALUE,
});

export const setCarBackViewPhotoValue = (value) => ({
    type: CAR_BACK_PHOTO_SET_VALUE,
    value,
});
export const setCarBackViewPhotoValid = (error) => ({
    type: CAR_BACK_PHOTO_SET_VALID,
    error,
});
export const resetCarBackViewPhotoValue = () => ({
    type: CAR_BACK_PHOTO_RESET_VALUE,
});

export const setChassisNumberPhotoValue = (value) => ({
    type: CHASSIS_NUMBER_PHOTO_SET_VALUE,
    value,
});
export const setChassisNumberPhotoValid = (error) => ({
    type: CHASSIS_NUMBER_PHOTO_SET_VALID,
    error,
});
export const resetChassisNumberPhotoValue = () => ({
    type: CHASSIS_NUMBER_PHOTO_RESET_VALUE,
});

export const setCarDashboardPhotoValue = (value) => ({
    type: INTERIOR_DASHBOARD_PHOTO_SET_VALUE,
    value,
});
export const setCarDashboardPhotoValid = (error) => ({
    type: INTERIOR_DASHBOARD_PHOTO_SET_VALID,
    error,
});
export const resetCarDashboardPhotoValue = () => ({
    type: INTERIOR_DASHBOARD_PHOTO_RESET_VALUE,
});

export const setInteriorRadioPhotoValue = (value) => ({
    type: INTERIOR_RADIO_PHOTO_SET_VALUE,
    value,
});
export const setInteriorRadioPhotoValid = (error) => ({
    type: INTERIOR_RADIO_PHOTO_SET_VALID,
    error,
});
export const resetInteriorRadioPhotoValue = () => ({
    type: INTERIOR_RADIO_PHOTO_RESET_VALUE,
});

export const setEnginePhotoValue = (value) => ({
    type: ENGINE_PHOTO_SET_VALUE,
    value,
});
export const setEnginePhotoValid = (error) => ({
    type: ENGINE_PHOTO_SET_VALID,
    error,
});
export const resetEnginePhotoValue = () => ({
    type: ENGINE_PHOTO_RESET_VALUE,
});

export const setSalesAgreementValue = (value) => ({
    type: SALES_AGREEMENT_SET_VALUE,
    value,
});
export const setSalesAgreementValid = (error) => ({
    type: ENGINE_PHOTO_SET_VALID,
    error,
});
export const resetSalesAgreementValue = () => ({
    type: SALES_AGREEMENT_RESET_VALUE,
});

export const setCarLeftPhotoValue = (value) => ({
    type: CAR_LEFT_PHOTO_SET_VALUE,
    value,
});
export const setCarLeftPhotoValid = (error) => ({
    type: CAR_LEFT_PHOTO_SET_VALID,
    error,
});
export const resetCarLeftPhotoValue = () => ({
    type: CAR_LEFT_PHOTO_RESET_VALUE,
});

export const setCarRightPhotoValue = (value) => ({
    type: CAR_RIGHT_PHOTO_SET_VALUE,
    value,
});
export const setCarRightPhotoValid = (error) => ({
    type: CAR_RIGHT_PHOTO_SET_VALID,
    error,
});
export const resetCarRightPhotoValue = () => ({
    type: CAR_RIGHT_PHOTO_RESET_VALUE,
});
